import { render, staticRenderFns } from "./TermsPersonalData.vue?vue&type=template&id=3c3fc95a&scoped=true"
import script from "./TermsPersonalData.vue?vue&type=script&lang=js"
export * from "./TermsPersonalData.vue?vue&type=script&lang=js"
import style0 from "./TermsPersonalData.vue?vue&type=style&index=0&id=3c3fc95a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3fc95a",
  null
  
)

export default component.exports